import { render } from "./CertificateOfComplianceTemplate.vue?vue&type=template&id=884448a0&scoped=true&ts=true"
import script from "./CertificateOfComplianceTemplate.vue?vue&type=script&lang=ts"
export * from "./CertificateOfComplianceTemplate.vue?vue&type=script&lang=ts"

import "./CertificateOfComplianceTemplate.vue?vue&type=style&index=0&id=884448a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-884448a0"]])

export default __exports__